<template>
  <div>
    <PageHeader title="Clientes Rurais" />
    <div class="row">
      <ClienteRuralSidebar
        :loading="loading"
        :telefone="telefone"
        :foto-perfil="fotoPerfil"
        :cliente-rural="clienteRural"
        @updateFotoPerfil="atualizarFoto"
        @update:loading="loading = $event"
        :modo-edicao-foto="modoEdicaoFotoClienteRural"
      />

      <ClienteRuralTabs v-model="tabIndex">
        <!-- Aba Dados Pessoais -->
        <ClienteRuralTabItem
          @tabClick="tratarTabs"
          tab-name="dadosPessoais"
          :disabled="!isTabCompleted.dadosPessoais"
        >
          <template #title>
            <i class="mdi mdi-account me-2"></i>
            <span>Dados Pessoais</span>
          </template>

          <dadosPessoais
            @next="avancar"
            ref="dadosPessoaisRef"
            next-tooltip="Próximo"
            @enableTab="enableTab"
            :show-next-button="false"
            tooltip-location="bottom"
            :foto-perfil="fotoPerfil"
            :visibilidade-botao="false"
            @salvarErro="tratarSalvarErro"
            @dadosSalvos="tratarDadosSalvos"
            @updateFotoPerfil="atualizarFoto"
            @modoEdicaoAtivo="tratarModoEdicao"
            :next-disabled="!isTabCompleted.contatos"
            @atualizarLoading="atualizarLoadingSalvar"
            @fotoParaSalvar="receberFotoParaSalvamento"
            @atualizarEstadoBotao="atualizarEstadoBotaoSalvar"
            @insertNomeClienteRural="atualizarNomeClienteRural"
          />

          <ClienteRuralTabNavigation
            @next="avancar"
            next-tooltip="Próximo"
            :template-footer="true"
            tooltip-location="bottom"
            :visibilidade-botao="true"
            :salvar-loading="loadingSalvar"
            @salvar="executarSalvarDadosPessoais"
            :next-disabled="!isTabCompleted.contatos"
            :show-next-button="mostrarBotaoProximoDadosPessoais"
            :show-salvar-button="mostrarBotaoSalvarDadosPessoais"
            :salvar-disabled="!habilitaBotaoSalvar || loadingSalvar"
          />
        </ClienteRuralTabItem>

        <!-- Aba Contatos -->
        <ClienteRuralTabItem
          tab-name="contatos"
          @tabClick="tratarTabs"
          :disabled="!isTabCompleted.contatos"
        >
          <template #title>
            <i class="mdi mdi-card-account-phone"></i>
            <span class="ms-2">Contato</span>
          </template>

          <contatos
            @enableTab="enableTab"
            @salvar="salvarContatos"
            v-if="activeTab === 'contatos'"
            @visibilidade-botao="atualizarVisibilidadeBotao"
            @insertTelefoneClienteRural="atualizaTelefoneClienteRural"
          />

          <ClienteRuralTabNavigation
            @back="voltar"
            @next="avancar"
            next-tooltip="Próximo"
            :show-next-button="true"
            :show-back-button="true"
            tooltip-location="bottom"
            :next-disabled="!isTabCompleted.email"
            :visibilidade-botao="visibilidadeBotao"
          />
        </ClienteRuralTabItem>

        <!-- Aba Email -->
        <ClienteRuralTabItem
          :disabled="!isTabCompleted.email"
          tab-name="email"
          @tabClick="tratarTabs"
        >
          <template #title>
            <i class="mdi mdi-email icon-spacing"></i>
            <span class="ms-2">Email</span>
          </template>

          <email
            @salvar="salvarEmail"
            @enableTab="enableTab"
            v-if="activeTab === 'email'"
            @visibilidade-botao="atualizarVisibilidadeBotao"
          />

          <ClienteRuralTabNavigation
            @back="voltar"
            @next="avancar"
            next-tooltip="Próximo"
            :show-back-button="true"
            :show-next-button="true"
            tooltip-location="bottom"
            :visibilidade-botao="visibilidadeBotao"
            :next-disabled="!isTabCompleted.enderecos"
          />
        </ClienteRuralTabItem>

        <!-- Aba Endereços -->
        <ClienteRuralTabItem
          tab-name="enderecos"
          @tabClick="tratarTabs"
          :disabled="!isTabCompleted.enderecos"
        >
          <template #title>
            <i class="mdi mdi-home icon-spacing"></i>
            <span class="ms-2">Endereços</span>
          </template>

          <enderecos
            @enableTab="enableTab"
            @salvar="salvarEnderecos"
            v-if="activeTab === 'enderecos'"
            @visibilidade-botao="atualizarVisibilidadeBotao"
          />

          <ClienteRuralTabNavigation
            @back="voltar"
            @next="avancar"
            next-tooltip="Próximo"
            :show-back-button="true"
            :show-next-button="true"
            tooltip-location="bottom"
            next-button-text="Projetos"
            :visibilidade-botao="visibilidadeBotao"
            :next-disabled="!isTabCompleted.projetos"
          />
        </ClienteRuralTabItem>

        <!-- Aba Projetos -->
        <ClienteRuralTabItem
          tab-name="projetos"
          @tabClick="tratarTabs"
          :disabled="!isTabCompleted.projetos"
        >
          <template #title>
            <i class="mdi mdi-briefcase icon-spacing"></i>
            <span class="ms-2">Projetos</span>
          </template>

          <projetos v-if="activeTab === 'projetos'" />

          <ClienteRuralTabNavigation
            @back="voltar"
            @next="avancar"
            :show-back-button="true"
            tooltip-location="bottom"
            :visibilidade-botao="visibilidadeBotao"
          />
        </ClienteRuralTabItem>
      </ClienteRuralTabs>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/page-header";
import email from "@/components/astec/emailAstec";
import contatos from "@/components/astec/contatoAstec";
import enderecos from "@/components/astec/enderecoAstec";
import projetos from "@/components/astec/projetosClienteAstec";
import dadosPessoais from "@/components/astec/dadosPessoaisAstec";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

// Novos componentes
import ClienteRuralSidebar from "@/components/astec/clienteRural/ClienteRuralSidebar.vue";
import ClienteRuralTabs from "@/components/astec/clienteRural/ClienteRuralTabs.vue";
import ClienteRuralTabItem from "@/components/astec/clienteRural/ClienteRuralTabItem.vue";
import ClienteRuralTabNavigation from "@/components/astec/clienteRural/ClienteRuralTabNavigation.vue";

export default {
  name: "ClienteRuralCadastroEdicao",
  mixins: [clienteRuralMixin],
  components: {
    email,
    contatos,
    projetos,
    enderecos,
    PageHeader,
    dadosPessoais,
    ClienteRuralTabs,
    ClienteRuralTabItem,
    ClienteRuralSidebar,
    ClienteRuralTabNavigation,
  },
  data() {
    return {
      tabs: ["dadosPessoais", "contatos", "email", "enderecos", "projetos"],
      telefone: "",
      clienteRural: "",
      fotoPerfil: {
        base64: null,
        file: null,
      },
      tabIndex: 0,
      loading: false,
      isTabCompleted: {
        dadosPessoais: true,
        contatos: false,
        email: false,
        enderecos: false,
        projetos: false,
      },
      visibilidadeBotao: true,
      activeTab: "dadosPessoais",
      modoEdicao: false,
      modoEdicaoFotoClienteRural: false,
      habilitaBotaoSalvar: false,
      loadingSalvar: false,
      camposDadosPessoais: {
        cpfCnpj: "",
        clienteRural: "",
        cpfCnpjState: null,
        validacaoOk: false,
        selecaoCooperado: null,
      },
      modoEdicaoDadosPessoais: false,
      mostrarBotaoProximoDadosPessoais: false,
      mostrarBotaoSalvarDadosPessoais: true,
    };
  },

  methods: {
    atualizarFoto(novaFoto) {
      this.$set(this, "fotoPerfil", {
        base64: novaFoto.base64,
        file: novaFoto.file,
        base64Completo: novaFoto.base64Completo,
        nomeArquivo: novaFoto.nomeArquivo,
      });
    },

    tratarTabs(tab) {
      this.activeTab = tab;
    },

    avancar() {
      if (this.tabIndex < this.tabs.length - 1) {
        this.tabIndex++;
        this.tratarTabs(this.tabs[this.tabIndex]);
      }
    },

    voltar() {
      if (this.tabIndex > 0) {
        this.tabIndex--;
        this.tratarTabs(this.tabs[this.tabIndex]);
      }
    },

    enableTab(tab) {
      this.$set(this.isTabCompleted, tab, true);
    },

    atualizarVisibilidadeBotao(visibilidade) {
      this.visibilidadeBotao = visibilidade;
    },

    tratarModoEdicao(isValor) {
      this.modoEdicao = isValor;
      this.modoEdicaoDadosPessoais = isValor;

      if (isValor) {
        this.habilitarTodasAbas();
        this.mostrarBotaoProximoDadosPessoais = true;
        this.mostrarBotaoSalvarDadosPessoais = true;
      } else {
        this.mostrarBotaoProximoDadosPessoais = false;
        this.mostrarBotaoSalvarDadosPessoais = true;
      }

      this.modoEdicaoFotoClienteRural = isValor;
    },

    habilitarTodasAbas() {
      this.isTabCompleted = {
        email: true,
        projetos: true,
        contatos: true,
        enderecos: true,
        dadosPessoais: true,
      };
    },

    atualizarNomeClienteRural(nome) {
      this.clienteRural = nome;
    },

    atualizaTelefoneClienteRural(nrTelefone) {
      this.telefone = nrTelefone;
    },

    executarSalvarDadosPessoais() {
      if (this.$refs.dadosPessoaisRef) {
        this.$refs.dadosPessoaisRef.salvarDadosPessoais();
      }
    },
    atualizarEstadoBotaoSalvar(estado) {
      this.habilitaBotaoSalvar = estado.habilitado;
      this.camposDadosPessoais = {
        cpfCnpj: estado.cpfCnpj || "",
        clienteRural: estado.clienteRural || "",
        cpfCnpjState: estado.cpfCnpjState,
        validacaoOk: estado.validacaoOk || false,
        selecaoCooperado: estado.selecaoCooperado || null,
      };
    },

    atualizarLoadingSalvar(loading) {
      this.loadingSalvar = loading;
    },

    tratarDadosSalvos() {
      if (!this.modoEdicaoDadosPessoais) {
        this.enableTab("contatos");
        this.mostrarBotaoProximoDadosPessoais = false;

        this.$nextTick(() => {
          this.tabIndex = 1;
          this.activeTab = "contatos";
        });
      }
      this.ativaModoEdicao();
    },

    ativaModoEdicao() {
      this.modoEdicaoDadosPessoais = true;
    },

    tratarSalvarErro(mensagemErro) {
      console.error("Erro ao salvar dados pessoais:", mensagemErro);
    },
  },
};
</script>

<style scoped>
input[type="file"] {
  display: none;
}
</style>
